/**
 * djb2-variant string hash → base36. Deterministic and dependency-free — use
 * for stable keys / ids (React keys, memo cache keys, SSR-safe scope classes).
 * Not cryptographic.
 */
export function hashString(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
}

/** Stable hash of an object via its key-sorted JSON. */
export function fastHash(obj: object): string {
  return hashString(JSON.stringify(obj, Object.keys(obj).sort()));
}
